import { FilterCampaignProvider } from "../campaign/filter-campaign/filter-campaign.context";
import "./customer.scss";

import { Outlet } from "react-router-dom";
import { ListCardsProvider } from "./list-cards/list-cards.context";

export function Customer() {
  return (
    <div id="Customer" className="customer flex justify-center">
      <div className="w-full md:w-[80%]">
        <FilterCampaignProvider>
          <ListCardsProvider>
            <Outlet />
          </ListCardsProvider>
        </FilterCampaignProvider>
      </div>
    </div>
  );
}

export default Customer;
